import React, { Suspense, lazy } from "react";
import { Redirect, Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { DashboardPage } from "./pages/DashboardPage";
import { ProfileSettings } from "./modules/profile_settings";
import { SupportTicket } from "./modules/support_ticket";
import Notifications from "./modules/notifications/Notifications";

// ------------------------------- DISABLED -------------------------------
// import Buy from "./modules/dashboards/buy/Buy";
// import BuyGold from "./modules/dashboards/buy/BuyGold";
// import ContractMarketPage from './modules/dashboards/contract-market/ContractMarket'; 
// ------------------------------------------------------------------------

import TransactionCompleted from "./modules/dashboards/buy/TransactionCompleted";
import OrderList from "./modules/order_list/OrderList";
import Withdrawal from "./modules/withdrawal/Withdrawal";
import Activity from "./modules/activity/Activity";
import WithdrawalRequest from "./modules/withdrawal/WithdrawalRequest";

import KYC from "./modules/Kyc/kyc"

// const GoogleMaterialPage = lazy(() =>
//   import("./modules/GoogleMaterialExamples/GoogleMaterialPage")
// );

export default function BasePageRoutes() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <ContentRoute exact path="/dashboard" component={DashboardPage} />

        {/* <-----------------------< The following pages are disabled. >-----------------------> */}
        {/* <ContentRoute exact path="/dashboard/contract-market" component={ContractMarketPage} /> */}
        {/* <ContentRoute path="/dashboard/buy" component={Buy} /> */}
        {/* <ContentRoute path="/dashboard/buy-gold" component={BuyGold} /> */}

        <ContentRoute
          path="/dashboard/transaction-completed"
          component={TransactionCompleted}
        />
        <ContentRoute exact path="/order-list" component={OrderList} />
        <ContentRoute exact path="/support" component={SupportTicket} />
        <ContentRoute exact path="/withdrawal" component={Withdrawal} />
        <ContentRoute
          path="/withdrawal/withdraw-request"
          component={WithdrawalRequest}
        />
        <ContentRoute exact path="/activity" component={Activity} />
        <ContentRoute path="/profile-settings" component={ProfileSettings} />
        <ContentRoute path="/notifications" component={Notifications} />

        {/* KYC route */}
        <ContentRoute path="/kyc" component={KYC} />

        {/* <Redirect to="error/error-v1"/> */}
        <Redirect from="/*" to="/dashboard" />
      </Switch>
    </Suspense>
  );
}
